<template>
  <div>
    <header-nav :showMenu="true"></header-nav>
    <dashboard-side-menu></dashboard-side-menu>
    <div class="dashboard-sidemenu-backdrop" @click="closeSideBar"></div>
    <section class="dashboard-section">
      <div
        class="image-banner"
        style="background-image:url('/img/dashobaardbg.png');"
      >
        <!-- <b-img src="/img/dashobaardbg.png" fluid></b-img> -->
      </div>
      <b-container>
        <div class="dashboard-card-content">
          <slot />
        </div>
      </b-container>
    </section>
    <main-footer></main-footer>
  </div>
</template>

<script>
import HeaderNav from "../components/Header/Header";
import MainFooter from "../components/Footer/Footer";
import DashboardSideMenu from "../components/Dashboard/DashboardSideMenu";
import { commonFunctions } from "../Commonjs/commonFunctions";

export default {
  name: "dashboard_layout",
  components: {
    DashboardSideMenu,
    MainFooter,
    HeaderNav
  },
  methods: {
    closeSideBar() {
      commonFunctions.toggleDashboardSideBar();
    }
  }
};
</script>

<style></style>
